import * as RulesActions from 'app/modules/rules/actions'
import { connect } from 'react-redux'
import { compose, branch, renderNothing } from 'recompose'
import { bindActionCreators } from 'redux'
import { fetchOrgUsers } from 'app/modules/user/actions'
import { unfilteredOrgUsersByIdJS } from 'app/modules/user/selectors'
import { teams } from 'app/modules/teams/selectors'
import { makeHasGate } from 'app/modules/gates/selectors'
import { actualProperties } from 'app/modules/org/selectors'
import { currentUserLoaded } from 'app/modules/user/selectors'
import { patchOrgProperties } from 'app/modules/org/actions'

import RulesHomeLayout from '../layouts/RulesHome'

import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'

function mapStateToProps(state) {
  return {
    rules: state.get('rules').get('rules'),
    onCall: state.get('rules').get('onCall'),
    rulesLoading: state.get('rules').get('rulesLoading'),
    users: unfilteredOrgUsersByIdJS(state),
    teams: teams(state),
    hasVisualRoutingBuilder: makeHasGate('HAS_VISUAL_ROUTING_BUILDER')(state),
    currentUserLoaded: currentUserLoaded(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...RulesActions, fetchOrgUsers, patchOrgProperties }, dispatch),
  }
}

export default compose(
  withOrgTeams,
  connect(mapStateToProps, mapDispatchToProps),
  branch(props => (!props.currentUserLoaded), renderNothing),
  branch(props => (props.hasVisualRoutingBuilder), () => {
    setTimeout(() => window.location.replace('/settings2/rules'), 0)
    renderNothing()
  }),
)(RulesHomeLayout)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/containers/RulesHome.js